/**
 * src/pages/ShippingReturns.jsx
 * All text below is static — edit these constants directly with your real
 * policy, nothing here reads from Supabase.
 */
import { Helmet } from "react-helmet-async";

const SECTIONS = [
  {
    title: "Shipping",
    body: `We ship across India via trusted courier partners. Orders within Gurgaon are typically delivered the same or next day. Orders elsewhere in India are dispatched within 1 business day and usually arrive within 3-5 business days. You'll receive a call or WhatsApp update once your order is packed and on its way.`,
  },
  {
    title: "Returns",
    body: `Returns are accepted within 3 days of delivery. Items must be unused, unwashed, and have all original tags and packaging intact. To request a return, message us on WhatsApp with your order number and we'll guide you through the process. A return charge of ₹99 per item will be deducted from your refund amount.`,
  },
  {
    title: "Exchanges",
    body: `We currently do not offer direct exchanges. If you'd like a different size, colour, or design, you can return the original item and place a new order for the item you'd like instead. The applicable ₹99 return charge per item will be deducted from the refund of your original order.`,
  },
  {
    title: "Refunds",
    body: `Once your returned item is received and inspected, your refund will be processed via bank transfer within a few business days. The ₹99 return charge per item will be deducted from the refundable amount.`,
  },
  {
    title: "Damaged or Wrong Item",
    body: `If you receive a damaged or incorrect item, please message us on WhatsApp within 24 hours of delivery with a photo and your order number. We strongly recommend taking a clear unpacking video while opening your package. This helps us verify and resolve any issues quickly and ensures a smoother return or replacement process. In case of a damaged or incorrect item, we'll arrange a replacement or refund at no extra cost to you.`,
  },
];

export default function ShippingReturns() {
  return (
    <div className="container-sm section">
      <Helmet>
        <title>Shipping & Returns | Ritu Fashion Store</title>
        <meta name="description" content="Shipping timelines, return, exchange and refund policy for Ritu Fashion Store orders." />
      </Helmet>

      <h1 style={{ fontSize: "2rem", fontWeight: 800 }}>Shipping & Returns</h1>
      <p className="muted mt-2">Everything you need to know about delivery, returns and refunds.</p>

      <div className="mt-8">
        {SECTIONS.map((s) => (
          <div key={s.title} className="card mt-4" style={{ padding: 20, background: "var(--secondary)" }}>
            <h2 style={{ fontSize: "1.125rem", fontWeight: 700 }}>{s.title}</h2>
            <p className="muted mt-2" style={{ lineHeight: 1.6, fontSize: 14 }}>{s.body}</p>
          </div>
        ))}
      </div>

      <p className="muted mt-8" style={{ fontSize: 14 }}>
        Still have a question? <a href="https://wa.me/919873804717" target="_blank" rel="noopener noreferrer">WhatsApp us</a> and we'll help right away.
      </p>
    </div>
  );
}